/**
  Author: Suneel Singh - suneel.singh@enabledata.com
  Purpose: Local storage API services
  Date: April 2020
**/

const LocalStorageService = (function () {
  let _service;
  function _getService() {
    if (!_service) {
      _service = this;
      return _service;
    }
    return _service;
  }
  function _setLoginInfo(tokenObj) {
    localStorage.setItem('accessToken', tokenObj.accessToken);
    localStorage.setItem('username', tokenObj.username);
    localStorage.setItem('refreshToken', tokenObj.refreshToken);
    localStorage.setItem('clientID', tokenObj.clientID);
    localStorage.setItem('tokenTimestamp', tokenObj.tokenTimestamp);
  }
  function _setUserInfo(userInfo) {
    localStorage.setItem('userInfo', userInfo);
  }

  function _setUserModuleAccess(obj) {
    localStorage.setItem('modules', obj);
  }
  function _setColor(color) {
    localStorage.setItem('color', color);
  }
  function _getColor() {
    return localStorage.getItem('color');
  }
  function _setFontColor(color) {
    localStorage.setItem('fontColor', color);
  }
  function _getFontColor() {
    return localStorage.getItem('fontColor');
  }
  function _setFontFamily(fontFamily) {
    localStorage.setItem('fontFamily', fontFamily);
  }
  function _getFontFamily() {
    return localStorage.getItem('fontFamily');
  }
  function _getAccessToken() {
    return localStorage.getItem('accessToken');
  }
  function _getClientID() {
    return localStorage.getItem('clientID');
  }
  function _getRefreshToken() {
    return localStorage.getItem('refreshToken');
  }
  function _getUserName() {
    return localStorage.getItem('username');
  }
  function _getUserInfo() {
    return localStorage.getItem('userInfo');
  }
  function _getUserModuleAccess() {
    return localStorage.getItem('modules');
  }
  function _getTokenTimestamp() {
    return localStorage.getItem('tokenTimestamp');
  }
  function _clearToken() {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('clientID');
    localStorage.removeItem('tokenTimestamp');
    localStorage.removeItem('username');
    localStorage.removeItem('userInfo');
    localStorage.removeItem('color');
    localStorage.removeItem('fontFamily');
    localStorage.removeItem('module');
  }
  function _setNotification(status) {
    localStorage.setItem('notification', status);
  }
  function _getNotification() {
    return localStorage.getItem('notification');
  }
  function _clearNotification() {
    localStorage.removeItem('notification');
  }
  return {
    getService: _getService,
    setLoginInfo: _setLoginInfo,
    setUserInfo: _setUserInfo,
    setUserModuleAccess: _setUserModuleAccess,
    //setAccessToken: _setAccessToken,
    getAccessToken: _getAccessToken,
    getRefreshToken: _getRefreshToken,
    getClientID: _getClientID,
    getUserName: _getUserName,
    getUserInfo: _getUserInfo,
    getUserModuleAccess: _getUserModuleAccess,
    clearToken: _clearToken,
    getColor: _getColor,
    setColor: _setColor,
    getFontColor: _getFontColor,
    setFontColor: _setFontColor,
    getFontFamily: _getFontFamily,
    setFontFamily: _setFontFamily,
    setNotification: _setNotification,
    getNotification: _getNotification,
    clearNotification: _clearNotification,
    getTokenTimestamp: _getTokenTimestamp,
  };
})();
export default LocalStorageService;
